import $ from 'jquery';
import { addNotification } from './notifications';

const toggleAdd = id => {
    const $toggle = $(`.add-to-favourites[data-id="${id}"]`);
    $toggle.removeClass('remove').addClass('add').html($toggle.data('add'));
};

const toggleRemove = id => {
    const $toggle = $(`.add-to-favourites[data-id="${id}"]`);
    $toggle.removeClass('add').addClass('remove').html($toggle.data('remove'));
};

const ajax = data => {
    $.ajax({
        url: tromplo.ajax_url,
        method: 'POST',
        data: data,
    })
        .done(response => {
            if (response['status'] === 'success') {
                addNotification(response['message']);
                if (data['do'] === 'add') {
                    toggleRemove(data['id']);
                }
                if (data['do'] === 'remove') {
                    toggleAdd(data['id']);
                }
            } else {
                addNotification(response['message'], 'error');
            }
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
};

export const toggleFavourites = $toggle => {
    if ($toggle.hasClass('add')) {
        ajax({
            action: 'favourites',
            id: +$toggle.data('id'),
            do: 'add',
        });
    } else {
        ajax({
            action: 'favourites',
            id: +$toggle.data('id'),
            do: 'remove',
        });
    }
};
